import moment from 'moment';

/** Opções no formato do Relatório de Atividades (MM/YYYY). */
export const buildMonthSelectOptions = (monthsBack = 12) =>
  Array.from({ length: monthsBack + 1 }, (_, i) => {
    const m = moment().subtract(i, 'month');
    const mmYyyy = m.format('MM/YYYY');
    return {
      value: mmYyyy,
      label: mmYyyy,
      mesRef: m.format('YYYY-MM'),
    };
  });

export const mesRefFromMmYyyy = (mmYyyy) => moment(mmYyyy, 'MM/YYYY', true).format('YYYY-MM');

export const mmYyyyFromMesRef = (mesRef) => moment(mesRef, 'YYYY-MM', true).format('MM/YYYY');

export const currentMonthSelectOption = () => buildMonthSelectOptions(0)[0];

/** Formato YYYY-MM (igual ao dashboard de receitas). */
export const monthRefDefault = () => moment().format('YYYY-MM');
